/**
 * O que faz: Renderiza paginas hub por publico com CTA para formulario e WhatsApp.
 * Onde usa: Rotas publicas de publico especifico (`/crm-para-*`).
 * Conexoes: Recebe `hubSlug` via props, le `publicContent` e aplica schema FAQ.
 * Tabelas: Nao interage com Supabase; opera somente sobre conteudo aprovado.
 * Data: 09/05/2026
 */

import { Helmet } from "react-helmet-async";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import PublicContentLayout from "@/components/blog/PublicContentLayout";
import { LeadCaptureForm } from "@/components/blog/LeadCaptureForm";
import { StructuredData, buildFaqSchema } from "@/components/seo/StructuredData";
import { publicContent } from "@/content/generated/public-content";
import NotFound from "./NotFound";

type ContentHubPageProps = {
  hubSlug: string;
};

const ContentHubPage = ({ hubSlug }: ContentHubPageProps) => {
  const item = publicContent.find((content) => content.type === "hub" && content.slug === hubSlug);

  if (!item) return <NotFound />;

  const canonical = `https://crm.agenciagens.com.br${item.url}`;

  return (
    <PublicContentLayout title={item.title} description={item.description}>
      <Helmet>
        <title>{`${item.title} | Gens CRM`}</title>
        <meta name="description" content={item.description} />
        <link rel="canonical" href={canonical} />
      </Helmet>
      <StructuredData data={buildFaqSchema(item)} />

      <article className="public-article">
        <p className="public-card-meta">Atualizado em {item.updatedAt}</p>
        <ReactMarkdown remarkPlugins={[remarkGfm]}>{item.body}</ReactMarkdown>
      </article>

      <section className="public-section">
        <h2>Perguntas frequentes</h2>
        <div className="public-faq">
          {item.faqs.map((faq) => (
            <article key={faq.question} className="public-card">
              <h3>{faq.question}</h3>
              <p>{faq.answer}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="public-section">
        <h2>Falar com especialista</h2>
        <LeadCaptureForm ctaContext={item.ctaContext} sourceUrl={canonical} />
      </section>
    </PublicContentLayout>
  );
};

export default ContentHubPage;
